// import clone from 'clone'
// import { initialState } from '../index'
import { NON_TRADE_INIT_LOADING, NON_TRADE_INIT_SUCCESS, NON_TRADE_INIT_FAIL, NON_TRADE_LOAD_DATA } from '@/store/types'

export const init = {
  [NON_TRADE_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [NON_TRADE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [NON_TRADE_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [NON_TRADE_LOAD_DATA] (state, data) {
    state.nonTradeData.branch = data.branch
    state.nonTradeData.accountNo = data.accountNo
    state.nonTradeData.type = data.type
    state.nonTradeData.documentNo = data.documentNo
    state.nonTradeData.fund = data.fund
    state.nonTradeData.suffix = data.suffix
    state.nonTradeData.tranMode = data.tranMode
    state.nonTradeData.currency = data.currency
    state.nonTradeData.amount = data.amount
    state.nonTradeData.gstAmountAE = data.gstAE
    state.nonTradeData.gstAmount = data.gst
    state.nonTradeData.netAmount = data.netAmt
    state.nonTradeData.tranDate = data.tranDate
    state.nonTradeData.actionName = data.actionName
    state.nonTradeData.printDoc = data.printDoc
    state.nonTradeData.currencyRate = data.currencyRate
    state.nonTradeData.gstStatus = data.gstStatus
    state.nonTradeData.gstRate = data.gstRate
    state.nonTradeData.netLocAmount = data.netLocAmt
  }
}
